import React from 'react'
import {Link} from 'react-router-dom'


class SignupPage extends React.Component {
    constructor(){
        super()
        this.state={
            name: "",
            email: "",
            password: ""
        }
        this.emailChanger = this.emailChanger.bind(this)
        this.passwordChanger = this.passwordChanger.bind(this)
        this.nameChanger = this.nameChanger.bind(this)
    }

    nameChanger(event){
        this.setState({
            name: event.target.value
        })
    }

    emailChanger(event){
        this.setState({
            email: event.target.value
        })
    }

    passwordChanger(event){
        this.setState({
            password: event.target.value
        })
    }

    login(){
        alert(`${this.state.email} ${this.state.password}`)
    }


    render() {
        return (
            <div className="columns">
                <div className="column is-half is-offset-one-quarter">
                    <div className="section">
                    <div className="field">
                            <div className="control has-icons-left">
                                <input type="email" className="input" placeholder="Name" value={this.state.name} onChange={this.nameChanger} />
                                <span className="icon is-left"><i class="fas fa-user"></i></span>
                            </div>
                        </div>
                        <div className="field">
                            <div className="control has-icons-left">
                                <input type="email" className="input" placeholder="Email" value={this.state.email} onChange={this.emailChanger} />
                                <span className="icon is-left"><i class="fas fa-envelope"></i></span>
                            </div>
                        </div>
                        <div className="field">
                            <div className="control has-icons-left">
                                <input type="password" className="input" placeholder="Password" value={this.state.password} onChange={this.passwordChanger} />
                                <span class="icon is-left">
                                    <i class="fas fa-lock"></i>
                                </span>
                            </div>

                        </div>
                        <div className="container ">
                            <p className="is-color1">Already have a account? <Link to="/login" className="is-size-5" >Login</Link> </p>
                            <button className="button is-primary px-4 is-pulled-right" onClick={()=>{this.login()}}>Login</button>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}


export default SignupPage